{
  "id": "placement",
  "text": "PLACEMENT_SET",
  "variant": "locked",
  "src": "/proof/video/placement.mp4",
  "poster": "/proof/video/placement-poster.jpg",
  "posterTime": 1.2,
  "duration": 6.0,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.4802,
      "left": 0.244,
      "width": 0.5981,
      "height": 0.2946
    },
    {
      "t": 0.5,
      "top": 0.4803,
      "left": 0.2476,
      "width": 0.6069,
      "height": 0.2989
    },
    {
      "t": 1.0,
      "top": 0.4802,
      "left": 0.2468,
      "width": 0.6221,
      "height": 0.3064
    },
    {
      "t": 1.5,
      "top": 0.4821,
      "left": 0.2389,
      "width": 0.6463,
      "height": 0.3183
    },
    {
      "t": 2.0,
      "top": 0.4816,
      "left": 0.2284,
      "width": 0.6741,
      "height": 0.332
    },
    {
      "t": 2.5,
      "top": 0.4771,
      "left": 0.2226,
      "width": 0.7003,
      "height": 0.345
    },
    {
      "t": 3.0,
      "top": 0.4714,
      "left": 0.223,
      "width": 0.7324,
      "height": 0.3607
    },
    {
      "t": 3.5,
      "top": 0.4671,
      "left": 0.221,
      "width": 0.7786,
      "height": 0.3835
    },
    {
      "t": 4.0,
      "top": 0.4603,
      "left": 0.1766,
      "width": 0.8234,
      "height": 0.4056
    },
    {
      "t": 4.5,
      "top": 0.4557,
      "left": 0.1252,
      "width": 0.8748,
      "height": 0.4309
    },
    {
      "t": 5.0,
      "top": 0.4539,
      "left": 0.0686,
      "width": 0.9314,
      "height": 0.4588
    },
    {
      "t": 5.5,
      "top": 0.4487,
      "left": 0.0141,
      "width": 0.9859,
      "height": 0.4856
    },
    {
      "t": 5.958,
      "top": 0.4463,
      "left": 0.0,
      "width": 1.0,
      "height": 0.5275
    }
  ]
}
